/** Мок-данные журнала операций для вёрстки (всего 58 записей, на странице по 10) */

export const OPERATIONS_JOURNAL_TOTAL = 58;
export const OPERATIONS_JOURNAL_PAGE_SIZE = 10;

const BASE_ROWS = [
  {
    id: 1,
    date: "01.01.2026",
    document: "AB-000001",
    hasWarning: false,
    organization: "TOO AQMOL-proBIM",
    accountDt: "Денежные средства в кассе",
    accountKt: "Нераспределенная прибыль",
    analyticsDt: [
      { label: "Проект", value: "ЖК Riverside" },
      { label: "Отделение", value: "РП МЖК" },
      { label: "Статья ОПИУ", value: "Доход от оказания услуг по РП МЖК" },
      { label: "Контрагент", value: "BI Group" },
    ],
    analyticsKt: [
      { label: "Контрагент", value: "BI Group" },
      { label: "Договор", value: "Д-2024-114" },
    ],
    quantity: 1,
    amount: 15000000,
    source: "1C NSK",
    dataType: "Факт 1С Бух",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: "Доход от оказания услуг по РП МЖК",
    articleOpiuKt: null,
    cfoOpiuDt: null,
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: "ЖК Riverside",
    projectKt: null,
    departmentDt: "РП МЖК",
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: "BI Group",
    employeeDt: null,
    employeeKt: null,
    contractDt: null,
    contractKt: "Д-2024-114",
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: null,
    cashAccountKt: null,
    workTypeDt: null,
    workTypeKt: null,
  },
  {
    id: 2,
    date: "01.01.2026",
    document: "БП-001231",
    hasWarning: false,
    organization: "TOO AQMOL-proBIM",
    accountDt: "Денежные средства в кассе",
    accountKt: "Нераспределенная прибыль",
    analyticsDt: [
      { label: "Статья ОПИУ", value: "Прочие расходы" },
      { label: "ЦФО ОПИУ", value: "Директорат" },
    ],
    analyticsKt: [{ label: "Сотрудник", value: "Иванов И." }],
    quantity: 1,
    amount: 850000,
    source: "Портал",
    dataType: "Факт 1С Бух",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: "Прочие расходы",
    articleOpiuKt: null,
    cfoOpiuDt: "Директорат",
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: null,
    projectKt: null,
    departmentDt: null,
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: null,
    employeeDt: null,
    employeeKt: "Иванов И.",
    contractDt: null,
    contractKt: null,
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: null,
    cashAccountKt: null,
    workTypeDt: null,
    workTypeKt: null,
  },
  {
    id: 3,
    date: "01.01.2026",
    document: "KO-000088",
    hasWarning: true,
    organization: "TOO AQMOL-project",
    accountDt: "Основные средства",
    accountKt: "Нераспределенная прибыль",
    analyticsDt: [{ label: "Денежный счет", value: "р/с БЦК" }],
    analyticsKt: [{ label: "Проект", value: "ЖК Riverside" }],
    quantity: 1,
    amount: 45200000,
    source: "Финансист",
    dataType: "Корректировка",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: null,
    articleOpiuKt: null,
    cfoOpiuDt: null,
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: null,
    projectKt: "ЖК Riverside",
    departmentDt: null,
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: null,
    employeeDt: null,
    employeeKt: null,
    contractDt: null,
    contractKt: null,
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: "Кран башенный №3",
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: "р/с БЦК",
    cashAccountKt: null,
    workTypeDt: null,
    workTypeKt: null,
  },
  {
    id: 4,
    date: "01.01.2026",
    document: "ЗП-000102",
    hasWarning: false,
    organization: "TOO AQMOL-proBIM",
    accountDt: "Денежные средства в кассе",
    accountKt: "Нераспределенная прибыль",
    analyticsDt: [
      { label: "Проект", value: "Alma Tower" },
      { label: "Отделение", value: "РП МЖК" },
    ],
    analyticsKt: [
      { label: "Контрагент", value: "КазСтальГрупп" },
      { label: "Договор", value: "Д-2025-007" },
    ],
    quantity: 1,
    amount: 9800000,
    source: "1C NSK",
    dataType: "Факт 1С Бух",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: null,
    articleOpiuKt: null,
    cfoOpiuDt: null,
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: "Alma Tower",
    projectKt: null,
    departmentDt: "РП МЖК",
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: "КазСтальГрупп",
    employeeDt: null,
    employeeKt: null,
    contractDt: null,
    contractKt: "Д-2025-007",
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: null,
    cashAccountKt: null,
    workTypeDt: null,
    workTypeKt: null,
  },
  {
    id: 5,
    date: "01.01.2026",
    document: "AB-000411",
    hasWarning: false,
    organization: "TOO AQMOL-proBIM",
    accountDt: "Нераспределенная прибыль",
    accountKt: "Амортизация основных средств",
    analyticsDt: [{ label: "Статья ОПИУ", value: "Себестоимость" }],
    analyticsKt: [{ label: "Вид работ", value: "Архитектурные решения" }],
    quantity: 1,
    amount: 38750000,
    source: "1C NSK",
    dataType: "Факт 1С Бух",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: "Себестоимость",
    articleOpiuKt: null,
    cfoOpiuDt: null,
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: null,
    projectKt: null,
    departmentDt: null,
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: null,
    employeeDt: null,
    employeeKt: null,
    contractDt: null,
    contractKt: null,
    nomenclatureDt: "ABCD",
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: null,
    cashAccountKt: null,
    workTypeDt: "Архитектурные решения",
    workTypeKt: null,
  },
  {
    id: 6,
    date: "01.01.2026",
    document: "ПО-000553",
    hasWarning: true,
    organization: "TOO AQMOL-project",
    accountDt: "Нераспределенная прибыль",
    accountKt: "Обязательства по налогам сотрудников",
    analyticsDt: [{ label: "Статья ОПИУ", value: "Ком. расходы" }],
    analyticsKt: [{ label: "Денежный счет", value: "р/с Халык" }],
    quantity: 1,
    amount: 2100000,
    source: "Ручной ввод",
    dataType: "Корректировка",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: "Ком. расходы",
    articleOpiuKt: null,
    cfoOpiuDt: null,
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: null,
    projectKt: null,
    departmentDt: null,
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: "СтройМонтаж",
    employeeDt: null,
    employeeKt: null,
    contractDt: null,
    contractKt: null,
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: null,
    cashAccountKt: "р/с Халык",
    workTypeDt: null,
    workTypeKt: null,
  },
  {
    id: 7,
    date: "01.01.2026",
    document: "РКО-00077",
    hasWarning: false,
    organization: "TOO AQMOL-proBIM",
    accountDt: "Денежные средства в кассе",
    accountKt: "Нераспределенная прибыль",
    analyticsDt: [
      { label: "Проект", value: "ЖК Riverside" },
      { label: "Отделение", value: "РП МЖК" },
    ],
    analyticsKt: [
      { label: "Контрагент", value: "ТехАренда" },
      { label: "Сотрудник", value: "Петрова М." },
    ],
    quantity: 1,
    amount: 6400000,
    source: "Портал",
    dataType: "Факт 1С Бух",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: null,
    articleOpiuKt: null,
    cfoOpiuDt: null,
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: "ЖК Riverside",
    projectKt: null,
    departmentDt: "РП МЖК",
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: "ТехАренда",
    employeeDt: null,
    employeeKt: "Петрова М.",
    contractDt: null,
    contractKt: null,
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: null,
    cashAccountKt: null,
    workTypeDt: null,
    workTypeKt: null,
  },
  {
    id: 8,
    date: "01.01.2026",
    document: "БП-001230",
    hasWarning: false,
    organization: "TOO AQMOL-proBIM",
    accountDt: "Денежные средства в кассе",
    accountKt: "Нераспределенная прибыль",
    analyticsDt: [
      { label: "Статья ОПИУ", value: "Прочие расходы" },
      { label: "ЦФО ОПИУ", value: "Бухгалтерия" },
    ],
    analyticsKt: [{ label: "Сотрудник", value: "Иванов И." }],
    quantity: 1,
    amount: 1250000,
    source: "1C NSK",
    dataType: "Факт 1С Бух",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: "Прочие расходы",
    articleOpiuKt: null,
    cfoOpiuDt: "Бухгалтерия",
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: null,
    projectKt: null,
    departmentDt: null,
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: null,
    employeeDt: null,
    employeeKt: "Иванов И.",
    contractDt: null,
    contractKt: null,
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: null,
    cashAccountKt: null,
    workTypeDt: null,
    workTypeKt: null,
  },
  {
    id: 9,
    date: "01.01.2026",
    document: "АВ-000902",
    hasWarning: false,
    organization: "TOO AQMOL-project",
    accountDt: "Основные средства",
    accountKt: "Нераспределенная прибыль",
    analyticsDt: [
      { label: "Проект", value: "Alma Tower" },
      { label: "Денежный счет", value: "р/с БЦК" },
    ],
    analyticsKt: [{ label: "Контрагент", value: "СтройМонтаж" }],
    quantity: 1,
    amount: 22100000,
    source: "Финансист",
    dataType: "Корректировка",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: null,
    articleOpiuKt: null,
    cfoOpiuDt: null,
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: "Alma Tower",
    projectKt: null,
    departmentDt: null,
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: "СтройМонтаж",
    employeeDt: null,
    employeeKt: null,
    contractDt: null,
    contractKt: null,
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: "р/с БЦК",
    cashAccountKt: null,
    workTypeDt: null,
    workTypeKt: null,
  },
  {
    id: 10,
    date: "01.01.2026",
    document: "ПКО-00045",
    hasWarning: false,
    organization: "TOO AQMOL-proBIM",
    accountDt: "Денежные средства в кассе",
    accountKt: "Нераспределенная прибыль",
    analyticsDt: [
      { label: "Проект", value: "ЖК Riverside" },
      { label: "Отделение", value: "РП МЖК" },
    ],
    analyticsKt: [
      { label: "Контрагент", value: "BI Group" },
      { label: "Договор", value: "Д-2024-114" },
    ],
    quantity: 1,
    amount: 9660000,
    source: "1C NSK",
    dataType: "Факт 1С Бух",
    budgetVersion: null,
    comment: null,
    articleOpiuDt: null,
    articleOpiuKt: null,
    cfoOpiuDt: null,
    cfoOpiuKt: null,
    articleDdsDt: null,
    articleDdsKt: null,
    cfoDdsDt: null,
    cfoDdsKt: null,
    projectDt: "ЖК Riverside",
    projectKt: null,
    departmentDt: "РП МЖК",
    departmentKt: null,
    counterpartyDt: null,
    counterpartyKt: "BI Group",
    employeeDt: null,
    employeeKt: null,
    contractDt: null,
    contractKt: "Д-2024-114",
    nomenclatureDt: null,
    nomenclatureKt: null,
    fixedAssetDt: null,
    fixedAssetKt: null,
    intangibleAssetDt: null,
    intangibleAssetKt: null,
    cashAccountDt: null,
    cashAccountKt: null,
    workTypeDt: null,
    workTypeKt: null,
  },
];

const MOCK_DATES = [
  "15.01.2026",
  "10.01.2026",
  "05.01.2026",
  "28.12.2025",
  "20.12.2025",
  "12.12.2025",
  "25.11.2025",
  "14.11.2025",
  "03.11.2025",
  "01.01.2026",
];

const MOCK_COMMENTS = [
  null,
  null,
  "Оплата по договору",
  null,
  "Корректировка за период",
  null,
  null,
  "Аванс сотруднику",
  null,
  null,
  "Закрытие месяца",
];

/** Аналитики, для которых показывается способ заполнения (правило / маппинг) */
const ANALYTIC_FIELDS = [
  "articleOpiu",
  "cfoOpiu",
  "articleDds",
  "cfoDds",
  "project",
  "department",
  "counterparty",
  "employee",
  "contract",
  "nomenclature",
  "fixedAsset",
  "intangibleAsset",
  "cashAccount",
  "workType",
];

/** Для мока: аналитики дебета проставлены правилами, кредита — маппингом */
const buildOrigins = (row) => {
  const origins = {};
  ANALYTIC_FIELDS.forEach((field) => {
    if (row[`${field}Dt`]) origins[`${field}Dt`] = "rule";
    if (row[`${field}Kt`]) origins[`${field}Kt`] = "mapping";
  });
  return origins;
};

export const operationsJournalMock = Array.from(
  { length: OPERATIONS_JOURNAL_TOTAL },
  (_, index) => {
    const base = BASE_ROWS[index % BASE_ROWS.length];
    const [prefix, number] = base.document.split("-");
    const offset = Math.floor(index / BASE_ROWS.length);
    const documentNumber = String(Number(number) + offset * 10).padStart(
      number.length,
      "0"
    );

    return {
      ...base,
      id: index + 1,
      date: MOCK_DATES[(index * 3) % MOCK_DATES.length],
      document: `${prefix}-${documentNumber}`,
      comment: MOCK_COMMENTS[index % MOCK_COMMENTS.length],
      origins: buildOrigins(base),
    };
  }
);

/** История изменений операции, от новых к старым */
export const getOperationHistory = (row) => {
  if (row.fromApi) {
    const details = [
      row.registrator,
      row.journalNumber && `Журнал ${row.journalNumber}`,
      row.lineNo != null && `Строка ${row.lineNo}`,
    ]
      .filter(Boolean)
      .join(" · ");
    return [
      {
        id: "import",
        time: "",
        author: "1C Oper",
        title: "Проводка из журнала 1С",
        details,
        date: row.date,
      },
    ];
  }

  const origins = Object.values(row.origins || {});
  const rulesCount = origins.filter((origin) => origin === "rule").length;
  const mappingCount = origins.filter((origin) => origin === "mapping").length;

  const events = [
    {
      id: "import",
      time: "09:12",
      author: "Система",
      title: `Загружено из источника «${row.source}»`,
      details: `Тип данных: ${row.dataType}`,
    },
  ];
  if (rulesCount) {
    events.push({
      id: "rules",
      time: "09:13",
      author: "Система",
      title: "Применены правила разнесения",
      details: `Заполнено аналитик: ${rulesCount}`,
    });
  }
  if (mappingCount) {
    events.push({
      id: "mapping",
      time: "09:13",
      author: "Система",
      title: "Применён маппинг справочников",
      details: `Сопоставлено аналитик: ${mappingCount}`,
    });
  }
  if (row.comment) {
    events.push({
      id: "comment",
      time: "11:40",
      author: "Петрова М.",
      title: "Добавлен комментарий",
      details: row.comment,
    });
  }
  if (row.hasWarning) {
    events.push({
      id: "warning",
      time: "14:05",
      author: "Иванов И.",
      title: "Отмечено для проверки",
      details: "Требуется подтверждение аналитик",
    });
  }

  return events.map((event) => ({ ...event, date: row.date })).reverse();
};

const uniqueValues = (key) =>
  [...new Set(BASE_ROWS.map((row) => row[key]))].sort((a, b) =>
    a.localeCompare(b, "ru")
  );

export const ORGANIZATION_OPTIONS = uniqueValues("organization");
export const DATA_TYPE_OPTIONS = uniqueValues("dataType");
export const SOURCE_OPTIONS = uniqueValues("source");

/** "DD.MM.YYYY" → Date (00:00 локального времени) */
export const parseMockDate = (date) => {
  const [day, month, year] = date.split(".").map(Number);
  return new Date(year, month - 1, day);
};

const startOfDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

/** Границы периода включительно. Пустая дата проходит, только если фильтр не задан. */
export const matchesDateRange = (date, dateFrom, dateTo) => {
  if (!date) return !dateFrom && !dateTo;
  const value = parseMockDate(date);
  if (dateFrom && value < startOfDay(dateFrom)) return false;
  if (dateTo && value > startOfDay(dateTo)) return false;
  return true;
};

export const AMOUNT_UNITS = {
  tenge: { label: "₸", divider: 1 },
  thousand: { label: "тыс. ₸", divider: 1000 },
};

export const formatAmount = (value, unit = "tenge") => {
  if (value == null) return "—";
  const { label, divider } = AMOUNT_UNITS[unit] || AMOUNT_UNITS.tenge;
  const formatted = (Number(value) / divider).toLocaleString("ru-RU", {
    maximumFractionDigits: 1,
  });
  return `${formatted} ${label}`;
};

export const displayValue = (value) => {
  if (value == null || value === "") return "—";
  return value;
};
